import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  ISyscodesData,
  ISyscodesDataState
} from './SyscodesModels'
import { appApiEndPoints } from '../../constants/ApiEndPoints'
import ApiService from '../../services/ApiService'

const successResultMessage = 'successfully'

const initialState: ISyscodesDataState = {
  syscodesData: [],
  selectedConfigurationDetails: null,
  status: 'idle',
  error: null,
  syscodeModifyStatus: 'idle',
  syscodeDetailsError: null,
  tableFilters: {
    Enabled: 1
  },
  tablePagination: {
    PageNumber: 1,
    RecordsPerPage: 25,
  },
  tableSort: {
    SortBy: null,
    SortOrder: null,
  },
}

export const fetchData = createAsyncThunk('syscodes/fetchData', async (data) => {
  const response = await ApiService.getData(appApiEndPoints.syscodesDataURL, data)
  return response.data
})

export const updateSyscodeDetails = createAsyncThunk(
  'syscodes/updateSyscodeDetails',
  async (data: any) => {
    const response = await ApiService.putData(appApiEndPoints.syscodeItemURL, {}, data)
    return {request: data, response: response.data}
  },
)

export const SyscodesSlice = createSlice({
  name: 'syscodesData',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action?.payload
    },
    updateFilters: (state, action) => {
      state.tableFilters = action?.payload
    },
    updatePagination: (state, action) => {
      state.tablePagination = action?.payload
    },
    updateSort: (state, action) => {
      state.tableSort = action?.payload
    },
    resetSyscodeDetails: (state, action) => {
      state.syscodeModifyStatus = 'idle'
      state.selectedConfigurationDetails = null
      state.syscodeDetailsError = null
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.syscodesData = action?.payload as ISyscodesData[]
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.error?.message || 'Failed to fetch syscodes data'
      })
      
      .addCase(updateSyscodeDetails.fulfilled, (state, action) => {
        const result = action?.payload
        if (result?.response?.[0]?.Message?.toLowerCase().includes(successResultMessage)) {
          const index = state.syscodesData.findIndex(n => n.Syscode === result.request.SysCode);
          state.syscodesData[index] = { ...state.syscodesData[index], Enabled: result.request.Enabled};
          state.syscodeModifyStatus = 'succeeded'
        } else {
          state.syscodeModifyStatus = 'failed'
          state.syscodeDetailsError = result.response[0].Message || 'Failed to save syscode'
        }
      })
      .addCase(updateSyscodeDetails.rejected, (state, action) => {
        state.syscodeModifyStatus = 'failed'
        state.syscodeDetailsError = action?.error?.message || 'Failed to update syscode'
      })
      .addCase(updateSyscodeDetails.pending, (state) => {
        state.syscodeDetailsError = ''
        state.syscodeModifyStatus = 'loading'
      })
      
  },
})
export const { setError, updateFilters, updatePagination, updateSort, resetSyscodeDetails } =
  SyscodesSlice.actions
export default SyscodesSlice.reducer
